import React from 'react';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';
import Layout from '../layout/Layout';

const CGV_ARTICLES = [
  {
    n: 1,
    title: 'Objet',
    body: `Les présentes conditions générales de vente régissent les relations contractuelles entre l'auto-entreprise The English Speaking Center et le client. Toute inscription et recours aux prestations délivrées par The English Speaking Center implique l'acceptation sans réserve des présentes conditions générales de vente qui prévaudront sur toutes autres conditions générales ou particulières non expressément agréées par The English Speaking Center.`,
  },
  {
    n: 2,
    title: 'Projet pédagogique et services',
    body: `Le projet pédagogique de The English Speaking Center est de permettre à chacun, quel que soit son âge, de participer à une activité en langue anglaise, selon son rythme personnel et ses besoins du moment. Les prestations sont délivrées sous la forme de séances d'animation en langue anglaise dispensées dans le centre pédagogique « The English Speaking Center », par des intervenants pédagogiques de culture anglo-saxonne tout au long d'une saison décomptée de septembre à juin, sur une base hebdomadaire pour les Ateliers, à raison de 29 séances d'1h ou 1h30 pour les enfants scolarisés et de séances d'1h30 ou de 2h pour les adultes sur l'année scolaire ou sur un stage pendant les vacances scolaires. Saisons réparties selon un calendrier fixé par The English Speaking Center. The English Speaking Center se réserve le droit d'annuler un atelier annuel, un stage vacances ou une séance si moins de 3 enfants ou adultes y sont inscrits moyennant une information communiquée au client au moins 48h à l'avance.`,
  },
  {
    n: 3,
    title: 'Prix',
    body: `Les tarifs indiqués sur les brochures tarifaires. Les prix sont libellés en euros et calculés hors taxes et TTC. TVA applicable au taux légal de 20% sur les prestations fournies par The English Speaking Center.`,
  },
  {
    n: 4,
    title: 'Paiements',
    body: `Le paiement est exigible dans sa totalité le jour de l'inscription. Le paiement est réalisé par chèques (sans frais), en espèces ou par prélèvement mensuel (RIB à joindre au moment de l'inscription). Les frais occasionnés par les prélèvements seront appliqués au client, selon le barème en vigueur de la banque émettrice. L'inscription vaut pour l'année.`,
  },
  {
    n: 5,
    title: 'Inscription',
    body: `Toute inscription ne devient définitive qu'après paiement effectué dans les conditions indiquées au point 4 ci-dessus.\nEn cas de déménagement des locaux dans un rayon de 10 km aucun remboursement des inscriptions ne pourra être effectué.`,
  },
  {
    n: 6,
    title: 'Absences',
    body: `Les absences ne peuvent pas être remboursées ou re-créditées. Les ateliers peuvent être rattrapés seulement en cas d'absence pour cause de maladie lorsque l'effectif dans un autre groupe le permet. Les absences pour autres raisons (départ en week-end) ne seront pas prioritaires.`,
  },
  {
    n: 7,
    title: 'Résiliation',
    body: `En s'inscrivant à un atelier ou à un stage, les participants s'engagent pour la saison entière ou le cycle entier. La mise en place des activités, et surtout leur maintien, reposent en effet sur l'engagement des participants à y prendre part durant toute la saison.\nAucune résiliation ne sera acceptée pour un stage vacances quel qu'en soit le motif. Pour une inscription annuelle, toute résiliation devra être notifiée par lettre recommandée avec accusé de réception à l'adresse suivante : The English Speaking Center – 9 Allée Jean Jaurès, 13800 Istres.\nSous réserve du respect de cette procédure, toute résiliation d'inscription reçue avant la quatrième séance, le cachet de la Poste faisant foi, fera l'objet d'un remboursement dans les 90 jours, déduction faite des frais d'inscription qui resteront définitivement acquis à The English Speaking Center. Par prix public, il faut entendre le prix hors offre spéciale ou promotionnelle. En revanche, l'inscription sera définitive pour la Saison à partir de la quatrième séance et aucune résiliation ne pourra plus être effectuée sauf cas grave de force majeure dument justifié par le client et soumis à l'appréciation de The English Speaking Center.\nDans ce cas, seuls les frais d'inscription et les séances et stages dispensés seront dus, les valeurs retenues étant celles du prix public hors offre spéciale ou promotionnelle. Le remboursement du solde sera alors effectué dans les 90 jours.`,
  },
  {
    n: 8,
    title: 'Non-sollicitation',
    body: `Le client s'engage à ne pas solliciter directement ou indirectement la/le/les intervenant(s) pédagogique(s) de The English Speaking Center et de recourir à leurs services pour toute autre mission que celle qui lui aura été confiée par The English Speaking Center.`,
  },
  {
    n: 9,
    title: 'Retard',
    body: `The English Speaking Center se réserve le droit de facturer au client des frais de garde d'un montant forfaitaire de 8 euros TTC par tranche de 15 minutes, au cas où un intervenant sera obligé de garder un enfant au-delà de l'horaire de sa séance en raison du retard de la personne chargée de récupérer l'enfant au centre pédagogique, et ce quel que soit le motif du retard.`,
  },
  {
    n: 10,
    title: 'Comportement — Discipline',
    body: `Dans le cas de comportements persistants d'un enfant portant atteinte de manière préjudiciable à la bonne conduite des ateliers, The English Speaking Center, après un premier avertissement auprès des parents qui serait resté sans effet, se réserve le droit d'exclure l'enfant pour une période temporaire ou définitive. Le règlement de la prestation souscrite restera intégralement dû à The English Speaking Center.`,
  },
  {
    n: 11,
    title: "Droit à l'image",
    body: `The English Speaking Center est autorisé, sauf décision contraire des parents, à photographier ou filmer les enfants lors des séances d'animation dans le cadre de leurs activités en groupe aux seules fins de diffusion sur les espaces internet de The English Speaking Center ou dans les grands médias d'information. Tout refus ou limitation d'une telle diffusion devra être mentionné sur la fiche d'inscription.`,
  },
  {
    n: 12,
    title: 'Matériel — Propriété intellectuelle',
    body: `Tout matériel (livres, revues, DVD, CD…) mis à disposition et utilisé dans le cadre des prestations dispensées par The English Speaking Center reste sa propriété exclusive.\nTous les éléments relatifs au contenu des prestations et sur les espaces internet de The English Speaking Center sont et restent la propriété intellectuelle exclusive de son titulaire. Il est strictement interdit de reproduire, exploiter, rediffuser ou utiliser de quelque manière, à quelque titre et pour quelque raison que ce soient, même partiellement, ces éléments sous quelque langue, forme, support et format que ce soit, sans l'accord préalable et écrit de The English Speaking Center.`,
  },
  {
    n: 13,
    title: 'Assurance',
    body: `The English Speaking Center est régulièrement assuré au titre des prestations fournies en responsabilité civile professionnelle. Toutefois, The English Speaking Center ne peut en aucun cas être tenu responsable de la perte, du vol et de la casse d'objets personnels appartenant aux enfants. Dans le cadre de leurs activités dans le centre, les familles s'engagent à souscrire une assurance responsabilité civile pour les enfants inscrits à The English Speaking Center.`,
  },
  {
    n: 14,
    title: 'Données à caractère personnel',
    body: `Conformément à la loi du 6 janvier 1978, le client dispose d'un droit d'accès, de modification, de rectification, d'opposition et de suppression des données nominatives le concernant exerçable auprès de The English Speaking Center.`,
  },
  {
    n: 15,
    title: 'Juridiction compétente',
    body: `Les présentes conditions générales de vente sont soumises à l'application du droit français. Les informations contractuelles et les produits proposés à la vente sont conformes à la législation française. Tout litige provenant de l'application des présentes conditions générales de vente sera soumis aux juridictions compétentes.`,
  },
];

const CGVPage = () => (
  <Layout>
    <div className="py-20 bg-white" data-testid="cgv-page">
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-10"
        >
          <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-4 rounded-full bg-blue-100 border border-blue-200">
            <FileText className="h-4 w-4 text-[#285BBB]" />
            <span className="text-[#285BBB] text-xs uppercase tracking-widest font-semibold">Dossier 2026-2027</span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-[#2C3C65] mb-4">
            Conditions Générales de Vente
          </h1>
          <p className="text-lg text-[#6777A1]">
            Les présentes conditions reprennent intégralement les CGV mentionnées dans le dossier d'inscription officiel signé par chaque famille.
          </p>
        </motion.div>

        <div className="space-y-8">
          {CGV_ARTICLES.map((art) => (
            <motion.article
              key={art.n}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="border-l-4 border-[#285BBB] pl-5"
              data-testid={`cgv-article-${art.n}`}
            >
              <h2 className="text-xl sm:text-2xl font-bold text-[#2C3C65] mb-3">
                Article {art.n} — {art.title}
              </h2>
              {art.body.split('\n').map((para, i) => (
                <p key={i} className="text-[#6777A1] leading-relaxed mb-3 last:mb-0 whitespace-pre-wrap">
                  {para}
                </p>
              ))}
            </motion.article>
          ))}
        </div>

        <div className="mt-12 bg-blue-50 border border-blue-100 rounded-2xl p-6 text-sm text-[#2C3C65]">
          <p className="font-semibold mb-1">Acceptation des CGV</p>
          <p className="text-[#6777A1]">
            Toute inscription en ligne ou sur dossier papier vaut acceptation sans réserve des présentes Conditions Générales de Vente.
          </p>
        </div>
      </div>
    </div>
  </Layout>
);

export default CGVPage;
